import { render, staticRenderFns } from "./TOTPBlackListDialog.vue?vue&type=template&id=4726c610&scoped=true"
import script from "./TOTPBlackListDialog.vue?vue&type=script&lang=ts"
export * from "./TOTPBlackListDialog.vue?vue&type=script&lang=ts"
import style0 from "./TOTPBlackListDialog.vue?vue&type=style&index=0&id=4726c610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4726c610",
  null
  
)

export default component.exports